import _get from 'lodash/get';


const getErrors = state => _get(state, 'siteFavicon.errors');
export const getLoadFaviconError = state => _get(getErrors(state), 'loadFaviconError');
export const getUploadFaviconError = state => _get(getErrors(state), 'uploadFaviconError');
export const getDeleteFaviconError = state => _get(getErrors(state), 'deleteFaviconError');
